"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12"
}, _react.default.createElement("path", {
  d: "M1 0h10c.27 0 .52.1.7.3.2.2.3.46.3.74v7.24c0 .28-.1.54-.3.73-.18.2-.43.3-.7.3H7.88c-.1 0-.19.03-.27.09l-3.84 2.52c-.34.22-.77-.03-.77-.44V9.83a.5.5 0 00-.5-.51H1a.98.98 0 01-.7-.3c-.2-.2-.3-.46-.3-.74V1.04C0 .76.1.5.3.3.47.1.72 0 1 0z"
}));

exports.default = _default;